export const fontFamilySansSerif = '"Exo 2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
export const fontFamilyHeadings = '"Alegreya Sans", -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial';

const vars = {
  fontSizeBasePx: 16,
  fontSizeBase: 16,
  fontSizeLg: 16 * 1.25,
  fontSizeSm: 16 * .875,
  fontSizeXs: 11,

  fontWeightLighter: 'lighter',
  fontWeightLight: 300,
  fontWeightNormal: 500,
  fontWeightBold: 700,
  fontWeightBolder: 'bolder',

  fontWeightBase: 500,
  lineHeightBase: 1.5,
  lineHeightLarge: 1.8,
  lineHeightSmall: 1.2,

  h1FontSize: 64,
  h2FontSize: 50,
  h3FontSize: 40,
  h4FontSize: 24,
  h5FontSize: 20,
  h6FontSize: 20,

  h1FontSizeSm: 40,
  h2FontSizeSm: 38,
  h3FontSizeSm: 30,
  h4FontSizeSm: 28,
  h5FontSizeSm: 19,
  h6FontSizeSm: 22,

  fontSizeHero: 90,
  fontSizeHeroSm: 46,

  headingsMarginTop: '0',
  headingsMarginBottom: '0.3em',
  headingsFontFamily: fontFamilyHeadings,
  headingsFontWeight: 900,
  headingsFontWeightLight: 700,
  headingsLineHeight: 1,
  fontSizeBtnSm: 12,
  fontSizeBtn: 14,
  letterSpacingLarge: '0.2em',
  letterSpacingMed: '0.07em',
};

export default vars;